import React, { useState } from 'react';
import { Modal, ModalBody, Button } from 'shards-react';
import Loading from './Loading';

const ConfirmModal = ({ message, confirmFunction, closeModal }) => {
	const [loading, setLoading] = useState(false);

	return (
		<Modal open={true} toggle={() => null} centered>
			{loading ? (
				<Loading style={{ height: '10vh' }} />
			) : (
				<ModalBody className='text-center px-4'>
					<h5>{message}</h5>
					<div className='d-flex justify-content-around'>
						{confirmFunction && (
							<Button
								theme='success'
								onClick={() => {
									setLoading(true);
									confirmFunction();
								}}
							>
								Bestätigen
							</Button>
						)}
						<Button theme='danger' onClick={closeModal}>
							Abbrechen
						</Button>
					</div>
				</ModalBody>
			)}
		</Modal>
	);
};

export default ConfirmModal;
